import { render, staticRenderFns } from "./LinkTile.vue?vue&type=template&id=f72d329c&scoped=true&"
import script from "./LinkTile.vue?vue&type=script&lang=js&"
export * from "./LinkTile.vue?vue&type=script&lang=js&"
import style0 from "./LinkTile.vue?vue&type=style&index=0&id=f72d329c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72d329c",
  null
  
)

export default component.exports